import React from 'react';

import MediaBigManage from './component';

export default React.memo(MediaBigManage);
